import React from 'react';
import styled from 'styled-components';
import { canvas, textPrimary, borderSubtle, infoLight, infoText } from '../../tokens/colors';
import { radiusPill } from '../../tokens/radii';

interface ChipProps {
  avatar?: string;
  avatarBg?: string;
  avatarColor?: string;
  onRemove?: () => void;
  children: React.ReactNode;
}

const ChipWrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 6px 4px 5px;
  border: 0.5px solid ${borderSubtle};
  border-radius: ${radiusPill};
  font-size: 11px;
  color: ${textPrimary};
  background: ${canvas};
`;

const Avatar = styled.div<{ $bg: string; $color: string }>`
  width: 20px; height: 20px;
  border-radius: 50%;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  font-size: 9px;
  font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
`;

const RemoveBtn = styled.button`
  width: 14px; height: 14px;
  border-radius: 50%;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  font-size: 8px;
  color: #9C9C96;
  padding: 0;
  opacity: 0.6;
  &:hover { background: #E5E4DE; opacity: 1; color: #A32D2D; }
`;

export const Chip: React.FC<ChipProps> = ({
  avatar,
  avatarBg = infoLight,
  avatarColor = infoText,
  onRemove,
  children,
}) => (
  <ChipWrap>
    {avatar && <Avatar $bg={avatarBg} $color={avatarColor}>{avatar}</Avatar>}
    <span style={{ padding: '0 3px' }}>{children}</span>
    {onRemove && (
      <RemoveBtn type="button" onClick={onRemove}>✕</RemoveBtn>
    )}
  </ChipWrap>
);
